import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { ApiService }                   from '../api/api.service';
import { BookingsAppointmentTypeModel } from './typings/bookings.appointment-type';
import { BookingsRequestModel }         from './typings/bookings.request';
import { BookingsRequestsComponent }    from './bookings.requests.component';
import { BookingsService }              from './bookings.service';
import { BookingsSettingsComponent }    from './bookings.settings.component';
import { CompanyMessagesModel }         from '../companies/models/company.messages';
import { CompanyService }               from '../companies/company.service';
import { CompanySettingsModel }         from '../companies/models/company.settings';
import { TableService }                 from '../table/table.service';

export const BookingsStates : Array<NgHybridStateDeclaration> = [
  {
    abstract: true,
    name    : 'app.bookings',
    url     : '/bookings'
  },
  {
    component: BookingsRequestsComponent,
    name     : 'app.bookings.requests',
    resolve  : [
      {
        deps     : [ BookingsService ],
        resolveFn: ( bookingsService : BookingsService ) : Promise<Array<BookingsAppointmentTypeModel>> => bookingsService.getAppointmentTypes(),
        token    : 'appointmentTypes'
      },
      {
        deps     : [ CompanyService ],
        resolveFn: ( companyService : CompanyService ) : Promise<CompanyMessagesModel> => companyService.getDefaultMessages(),
        token    : 'companyMessages'
      },
      {
        deps     : [ BookingsService, TableService ],
        resolveFn: ( bookingsService : BookingsService, tableService : TableService ) : Promise<Array<BookingsRequestModel>> => {
          const cache = tableService.getCacheForTable(bookingsService.requestTableCacheKey);

          return bookingsService.getRequests({
            direction: 'asc',
            field    : 'requested_date',
            offset   : 0,
            pageSize : cache.paging.pageSize
          });
        },
        token: 'requests'
      }
    ],
    url: '/requests'
  },
  {
    component: BookingsSettingsComponent,
    name     : 'app.bookings.settings',
    resolve  : [
      {
        deps     : [ BookingsService, TableService ],
        resolveFn: ( bookingsService : BookingsService, tableService : TableService ) : Promise<Array<BookingsAppointmentTypeModel>> => {
          const cache = tableService.getCacheForTable(bookingsService.appointmentsTypesTableCacheKey);

          return bookingsService.getAppointmentTypes({
              offset  : 0,
              pageSize: cache.paging.pageSize
            });
        },
        token: 'appointmentTypes'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : Promise<string> => apiService.get('/company_integrations'),
        token    : 'integrations'
      },
      {
        deps     : [ BookingsService ],
        resolveFn: ( bookingsService : BookingsService ) : Promise<string> => bookingsService.getMaskedCompanyId(),
        token    : 'maskedCompanyId'
      },
      {
        deps     : [ BookingsService ],
        resolveFn: ( bookingsService : BookingsService ) : Promise<CompanySettingsModel> => bookingsService.getSettings(),
        token    : 'settings'
      }
    ],
    url: '/settings'
  }
];
